/** Temporary end-to-end correlation for one live start. Keyed by device id + channel. */

const requestIds = new Map<string, string>();

function key(deviceId: string, channel: number): string {
  return `${deviceId}:${channel}`;
}

export function bindLiveTrace(deviceId: string, channel: number, requestId: string): void {
  if (!deviceId || !requestId) return;
  requestIds.set(key(deviceId, channel), requestId);
}

export function readLiveTrace(deviceId: string, channel: number): string {
  return requestIds.get(key(deviceId, channel)) ?? "";
}

export function newLiveRequestId(): string {
  return typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `r${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

export function logLiveTrace(
  stage: string,
  fields: Record<string, string | number | boolean | null | undefined>,
): void {
  const parts = Object.entries(fields)
    .filter(([, value]) => value != null && value !== "")
    .map(([name, value]) => `${name}=${value}`);
  console.info(`[live-trace] ${stage} ${parts.join(" ")} t=${Date.now()}`);
}

/** One line per live-start step: vehicle, channel, step, error, and how long the step took. */
export function logLiveStep(input: {
  vehicleId: string;
  channel: number;
  step: string;
  error?: string;
  durationMs?: number;
  httpStatus?: number;
  sessionId?: string;
}): void {
  logLiveTrace(input.step, {
    vehicleId: input.vehicleId,
    channel: input.channel,
    step: input.step,
    error: input.error,
    durationMs: input.durationMs,
    httpStatus: input.httpStatus,
    sessionId: input.sessionId,
  });
}
